export class CreateUserModel {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    isBusiness = true;
}